import React, { Component } from 'react';
import { Input, Grid, Segment, Button, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import TablePlaceList from './TablePlaceList';
import { HeaderTablePlaceList } from '../constant/HeaderTable';
import HeaderTitle from '../../../components/common/headerTitle';
import Pagination from '../../../components/common/pagination';
import {
  datasetPagination,
  getNumberFromTo,
} from '../../../scripts/pagination';
import FilterData from '../../../scripts/filterDataTable';

class PlaceList extends Component {
  constructor(props) {
    super(props);
    this.currentIndex = 0;
    this.state = {
      searchInput: '',
      activePage: 1,
    };
  }
  static propTypes = {
    data: PropTypes.array,
  };
  handleChange = (e, { name, value }) =>
    this.setState({ [name]: value, activePage: 1 });
  handleChangeDate = (value, name) => {
    this.setState({ [name]: value, activePage: 1 });
  };
  pageChange = (e, { activePage }) => {
    this.setState({ activePage });
  };

  render() {
    let { data, filterBy, buttonNew, butttonEdit, buttonDelete } = this.props;
    let { searchInput, activePage } = this.state;
    let filterData = FilterData(data, filterBy, searchInput);
    let pagedData = datasetPagination(filterData, 7);
    let listData = pagedData[activePage - 1];

    let { numbersFrom, numbersTo } = getNumberFromTo(listData, activePage, 7);
    let handleChange =
      filterBy === 'FormatedDate'
        ? this.handleChangeDate
        : filterBy === 'exchangeRate'
          ? this.handleChangeDate
          : this.handleChange;

    return (
      <div>
        <Grid columns="equal" style={{ marginTop: '30px' }}>
          <Grid.Row stretched>
            <Grid.Column>
              <Segment loading={this.props.loading}>
                <HeaderTitle title="Place List" />
                <Input
                  icon="search"
                  placeholder="search"
                  name="searchInput"
                  value={searchInput}
                  onChange={handleChange}
                />
                <Button onClick={buttonNew} positive floated="right">
                  <Icon name="add" />
                  Add New
                </Button>
                <TablePlaceList
                  data={data}
                  headerTable={HeaderTablePlaceList}
                  pageChange={this.pageChange}
                  listData={listData}
                  pagedData={pagedData}
                  butttonEdit={butttonEdit}
                  buttonDelete={buttonDelete}
                />
                <Pagination
                  pagedData={pagedData}
                  numbersTo={numbersTo}
                  numbersFrom={numbersFrom}
                  data={data}
                  pageChange={this.pageChange}
                  activePage={activePage}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

PlaceList.propTypes = {
  listData: PropTypes.array,
  pagedData: PropTypes.array,
  title: PropTypes.string,
  data: PropTypes.array,
  buttonNew: PropTypes.func,
  butttonEdit: PropTypes.func,
  buttonDelete: PropTypes.func,
  filterBy: PropTypes.string,
  loading: PropTypes.bool,
};

export default PlaceList;
